import React from 'react';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { YES_OPTION_KEY, NO_OPTION_KEY } from '../../marketplace-custom-config';
import { ListingLink } from '..';
import { EditListingBoardExperienceForm } from '../../forms';

import css from './EditListingBoardExperiencePanel.module.css';

const EditListingBoardExperiencePanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const { publicData, state } = currentListing.attributes || {};
  const { boardExperience } = publicData || {};

  const isPublished =
    currentListing.id && state !== LISTING_STATE_DRAFT;

  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingBoardExperiencePanel.title"
      values={{
        listingTitle: (
          <ListingLink listing={listing}>
            <FormattedMessage id="EditListingBoardExperiencePanel.listingTitle" />
          </ListingLink>
        ),
      }}
    />
  ) : (
    <FormattedMessage id="EditListingBoardExperiencePanel.createListingTitle" />
  );

  // Normalise stored value back into form field names
  const initialValues = boardExperience
    ? {
        hasExperience: boardExperience.hasExperience ? YES_OPTION_KEY : NO_OPTION_KEY,
        details: boardExperience.details || '',
      }
    : {};

  const handleSubmit = values => {
    const { hasExperience, details } = values;
    const hasExp = hasExperience === YES_OPTION_KEY;
    onSubmit({
      publicData: {
        boardExperience: {
          hasExperience: hasExp,
          details: hasExp ? (details || '') : null,
        },
      },
    });
  };

  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>
      <EditListingBoardExperienceForm
        className={css.form}
        initialValues={initialValues}
        saveActionMsg={submitButtonText}
        onSubmit={handleSubmit}
        onChange={onChange}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
      />
    </div>
  );
};

EditListingBoardExperiencePanel.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingBoardExperiencePanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingBoardExperiencePanel;
